import { Trans } from '@lingui/macro';
import { Box, Typography } from '@material-ui/core';
import { ReportProblemOutlined } from '@material-ui/icons';
import React from 'react';

export const GenericErrorPage = () => {
  return (
    <Box
      className='w-full h-full'
      display='flex'
      justifyContent='center'
      textAlign='center'
      flexDirection='column'
      alignItems='center'
    >
      <Box clone mb={1}>
        <ReportProblemOutlined color='error' className='extra-large' />
      </Box>

      <Typography variant='h4'>
        <Trans>Something went wrong.</Trans>
      </Typography>
      <Typography variant='h4'>
        <Trans>Please try again later</Trans>
      </Typography>
    </Box>
  );
};
